import "../SignIn/SignIn.css";
import { Col, Row, Button } from "react-bootstrap";
// import { FaFacebook } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import {
  FirstNameCheck,
  onlyNumberCheck,
} from "../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { GetBusinessCategory } from "../../Utils/Api/SignUP";
import { useEffect, useState } from "react";
import "react-step-progress/dist/index.css";
import Loader from "../../Components/Loader/Loader";

const BusinessInfo = ({ NextPrevBtn, BuData, city_id }) => {
  const [BusinessName, setBusinessName] = useState("");
  const [BusinessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("");

  const [selectNo_Employees, setSelectNo_Employees] = useState("");
  const [err_DisplayBusinessName, setErr_DisplayBusinessName] = useState("");
  const [
    err_DisplayBusinessRegistrationNumber,
    setErr_DisplayBusinessRegistrationNumber,
  ] = useState("");
  const [err_DisplayTypeOfBusiness, setErr_DisplayTypeOfBusiness] =
    useState("");
  const [err_displayNo_Employees, setErr_DisplayNo_Employees] = useState("");
  // const [err_displayBu_Category, setErr_Display_Bu_Category] = useState("");
  const onBusinessName = (event) => {
    setBusinessName(event.target.value);
    setErr_DisplayBusinessName("");
  };

  const businessCertification = [
    "LGBTQ+",
    "Minority",
    "Veteran",
    "Women Owned",
    "None Of The Above",
  ];

  const [selectedCertifications, setSelectedCertifications] = useState([]);

  const onBusinessRegisterationNumber = (event) => {
    setBusinessRegistrationNumber(event.target.value);
    setErr_DisplayBusinessRegistrationNumber("");
  };

  const onSelectNo_Employees = (e) => {
    setSelectNo_Employees(e.target.value);
    setErr_DisplayNo_Employees("");
  };

  const PreviousTabHandler = () => {
    let ClickVal = 1;
    NextPrevBtn("", ClickVal);
  };

  const SubmitHandler = (event) => {
    event.preventDefault();
    let ValidationCheck = true;

    const BusinessNameerr_Display = FirstNameCheck(BusinessName);
    const BusinessRegistrationerr_Display = onlyNumberCheck(
      BusinessRegistrationNumber
    );

    if (BusinessNameerr_Display.input === "empty") {
      setErr_DisplayBusinessName("Business Name is required!");
      ValidationCheck = false;
    } else if (BusinessNameerr_Display.input === "invalid") {
      setErr_DisplayBusinessName(BusinessNameerr_Display.err_display);
      ValidationCheck = false;
    }

    if (BusinessRegistrationerr_Display.input === "empty") {
      setErr_DisplayBusinessRegistrationNumber("Registration no. is required!");
      ValidationCheck = false;
    }
    // else if (BusinessRegistrationerr_Display.input === "invalid") {
    //   setErr_DisplayBusinessRegistrationNumber("Enter number only!");
    //   ValidationCheck = false
    // }

    // if (!selectBu_category) {
    //   setErr_Display_Bu_Category("Please select the Category!");
    //   selectvalidation = false;
    // }

    if (!selectNo_Employees) {
      setErr_DisplayNo_Employees("Please select the no. of employees!");
      ValidationCheck = false;
    }
    if (selectedCertifications.length === 0) {
      setErr_DisplayTypeOfBusiness("Type of Business is required!");
      ValidationCheck = false;
    }

    if (ValidationCheck === true) {
      let SignUpDetails = {
        bu_Business_name: BusinessName,
        bu_BusinessRegistration_no: BusinessRegistrationNumber,
        // bu_BusinessCategory: parseInt(selectBu_category),
        bu_owned_gender: selectedCertifications,
        bu_BusinessEmployees: selectNo_Employees,
        submitflag: true,
      };
      const NextSteperr_Display = 1;

      NextPrevBtn(NextSteperr_Display);
      BuData(SignUpDetails);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    if (name === "None Of The Above") {
      if (checked) {
        setSelectedCertifications(["None Of The Above"]);
      } else {
        setSelectedCertifications([]);
      }
    } else {
      if (checked) {
        setSelectedCertifications((prev) =>
          prev.filter((cert) => cert !== "None Of The Above").concat(name)
        );
      } else {
        setSelectedCertifications((prev) =>
          prev.filter((cert) => cert !== name)
        );
      }
    }
  };
  return (
    <>
      <div className="main">
        <Row className="justify-content-md-center py-3">
          <Col md="12" className="">
            <Row>
              <div className="signemail pt-3">
                <Form onSubmit={SubmitHandler} className="formmain signin-row">
                  <Row className="businessName">
                    <Col md="12">
                      <Form.Group className="" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Business Name <span className="star-required">*</span>
                          <p className="info-text-space">
                            &#40;Please avoid use of special characters unless
                            it is part of the business name (for ex !, @, %
                            etc.).&#41;
                          </p>
                        </Form.Label>

                        <Form.Control
                          type="input"
                          placeholder="Enter Business Name"
                          className="custom-formcontrol"
                          onChange={onBusinessName}
                          value={BusinessName}
                          maxLength={100}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={err_DisplayBusinessName} />
                      </Form.Group>
                    </Col>
                    {/* <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Business Category{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          onChange={onSelectBu_Category}
                          value={selectBu_category}
                        >
                          <option>Select Business Category</option>
                          {businessCategory?.length > 0
                            ? businessCategory.map((val) => {
                                return (
                                  <option
                                    value={val.category_id}
                                    key={val.category_id}
                                  >
                                    {val.category_name}
                                  </option>
                                );
                              })
                            : "No data"}
                        </Form.Select>
                        <ErrorLabel ErrorDisplay={err_displayBu_Category} />
                      </Form.Group>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group className="" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Business Registration No{" "}
                          <span className="star-required">*</span>
                          <p className="info-text-space">
                            &#40;Your state business license number&#41;
                          </p>
                        </Form.Label>
                        <Form.Control
                          // type="email"
                          placeholder="Business Registration No"
                          className="custom-formcontrol"
                          onChange={onBusinessRegisterationNumber}
                          value={BusinessRegistrationNumber}
                          maxLength={15}
                          autoComplete="off"
                        />
                        <ErrorLabel
                          ErrorDisplay={err_DisplayBusinessRegistrationNumber}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Number Of Employees{" "}
                          <span className="star-required">*</span>
                          <p
                            className="info-text-space"
                            style={{ visibility: "hidden" }}
                          >
                            &#40;Your state business license number&#41;
                          </p>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          onChange={onSelectNo_Employees}
                          value={selectNo_Employees}
                        >
                          <option>Select No of Employees</option>
                          <option value="0-10">0-10 employees</option>
                          <option value="11-25">11-25 employees</option>
                          <option value="26-50">26-50 employees</option>
                          <option value="51-100">51-100 employees</option>
                          <option value="101+">101+ employees</option>
                        </Form.Select>
                        <ErrorLabel ErrorDisplay={err_displayNo_Employees} />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group className="" controlId="formBasicEmail">
                        {/* <Form.Label className="form-label-custom">
                          Business Certification{" "}
                          <span className="star-required">*</span>
                          <p
                            style={{
                              color: "#ffffff",
                              fontSize: 12,
                            }}
                          >
                            (Select all that apply)
                          </p>
                        </Form.Label> */}
                        <Form.Label className="form-label-custom">
                          <div className="label-info-text">
                            Business Certification
                            <span className="star-required">*</span>
                            <p className="info-text-space">
                              &#40;Select all that apply&#41;
                            </p>
                          </div>
                        </Form.Label>
                        <Form className="text-white mt-2">
                          {businessCertification?.map((item) => (
                            <div key={item}>
                              <Form.Check
                                label={item}
                                name={item}
                                type="checkbox"
                                id={item}
                                onChange={handleCheckboxChange}
                                checked={selectedCertifications.includes(item)}
                              />
                            </div>
                          ))}
                        </Form>
                        <ErrorLabel ErrorDisplay={err_DisplayTypeOfBusiness} />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="text-center small-btns d-flex ">
                    <Link onClick={PreviousTabHandler}>
                      <p className="view">Previous</p>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                    >
                      Next
                    </Button>
                  </div>
                </Form>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BusinessInfo;
